// mcn-frontend/src/components/sections/LandingHeader.jsx
//
// IMPORTANT: This is now a thin wrapper around the shared layout Header.jsx.
// Previously this rendered its own white sticky header which made the homepage
// look completely different from inner pages. We now delegate to the real
// purple-gradient Header so the entire site uses ONE header source — edits
// flow through `components/layout/Header.jsx` + `Header.css`.
//
// ComponentRegistry passes `data` (the parsed header.json). The shared Header
// expects the prop name `headerData`, so we rename it here.
import React from 'react';
import Header from '../layout/Header';

const LandingHeader = ({ data }) => {
  return <Header headerData={data} />;
};

export default LandingHeader;
